import {
  AlertTriangle,
  CheckCircle2,
  CirclePause,
  UserRoundX,
} from 'lucide-react';

interface NewKPICardsProps {
  stats: {
    refused_campaigns?: number;
    pending_candidate?: number;
    pending_referents?: number;
    completed_campaigns?: number;
  } | undefined;
}

export const NewKPICards = ({ stats }: NewKPICardsProps) => {
  const cards = [
    {
      label: 'Refusées',
      value: stats?.refused_campaigns ?? 0,
      icon: UserRoundX,
      iconClassName: 'border border-rose-200/80 bg-rose-50/80 text-rose-600',
    },
    {
      label: 'En attente candidat',
      value: stats?.pending_candidate ?? 0,
      icon: CirclePause,
      iconClassName:
        'border border-amber-200/80 bg-amber-50/80 text-amber-600',
    },
    {
      label: 'En attente référents',
      value: stats?.pending_referents ?? 0,
      icon: AlertTriangle,
      iconClassName:
        'border border-[hsl(var(--app-border-subtle))] bg-[hsl(var(--app-surface-muted))] text-[hsl(var(--app-text-muted))]',
    },
    {
      label: 'Terminées',
      value: stats?.completed_campaigns ?? 0,
      icon: CheckCircle2,
      iconClassName:
        'border border-emerald-200/80 bg-emerald-50/80 text-emerald-600',
    },
  ] as const;

  return (
    <div className="grid grid-cols-1 gap-3 md:grid-cols-2 xl:grid-cols-4">
      {cards.map((card) => {
        const Icon = card.icon;

        return (
          <div key={card.label} className="app-surface rounded-[18px] p-4">
            <div className="flex items-start justify-between gap-4">
              <div>
                <p className="text-[11px] font-semibold uppercase tracking-[0.14em] text-[hsl(var(--app-text-muted))]">
                  {card.label}
                </p>
                <div className="mt-2 text-[24px] font-semibold leading-none tracking-[-0.03em] text-[hsl(var(--app-text-strong))]">
                  {card.value}
                </div>
              </div>
              <div className={`rounded-2xl p-2 ${card.iconClassName}`}>
                <Icon className="h-[17px] w-[17px]" />
              </div>
            </div>
          </div>
        );
      })}
    </div>
  );
};
